import Vue from "vue";
import VueRouter from "vue-router";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
    component: () => import("../pages/index.vue"),
    children: [
      {
        path: "/home",
        name: "index",
        component: () => import("../pages/index.vue"),
        meta: {
          level: 2,
        },
      },
      {
        path: "/information",
        name: "information",
        component: () => import("../pages/information"),
        meta: {
          level: 2,
        },
      },
      {
        path: "/activity",
        name: "activity",
        component: () => import("../pages/activity"),
        meta: {
          level: 2,
        },
      },
      {
        path: "/live",
        name: "live",
        component: () => import("../pages/live"),
        meta: {
          level: 2,
        },
      },
      {
        path: "/video",
        name: "videos",
        component: () => import("../pages/video"),
        meta: {
          level: 2,
        },
      },
      {
        path: "/localFeature",
        name: "localFeature",
        component: () => import("../pages/localFeature"),
        meta: {
          level: 2,
        },
      },
      {
        path: "/exhibition",
        name: "exhibition",
        component: () => import("../pages/exhibition"),
        meta: {
          level: 2,
        },
      },
      {
        path: "/appreciation",
        name: "appreciation",
        component: () => import("../pages/appreciation"),
        meta: {
          level: 2,
        },
      },
      {
        path: "/teacher",
        name: "teacher",
        component: () => import("../pages/teacher"),
        meta: {
          level: 2,
        },
      },
      {
        path: "/mooc",
        name: "mooc",
        component: () => import("../pages/mooc"),
        meta: {
          level: 2,
        },
      },
      {
        path: "/space",
        name: "space",
        component: () => import("../pages/space"),
        meta: {
          level: 2,
        },
      },
      {
        path: "/team",
        name: "team",
        component: () => import("../pages/team"),
        meta: {
          level: 2,
        },
      },
      {
        path: "/team/detail/:id",
        name: "teamDetail",
        component: () => import("../pages/teamDetail"),
        meta: {
          level: 3,
        },
      },
      {
        path: "/information/detail/:id",
        name: "informationDetail",
        component: () => import("../pages/informationDetail"),
        meta: {
          level: 3,
        },
      },
      {
        path: "/activity/detail/:id",
        name: "activityDetail",
        component: () => import("../pages/activityDetail"),
      },
      {
        path: "/exhibition/detail/:id",
        name: "exhibitionDetail",
        component: () => import("../pages/exhibitionDetail"),
        meta: {
          level: 3,
        },
      },
      {
        path: "/appreciation/detail/:id",
        name: "appreciationDetail",
        component: () => import("../pages/appreciationDetail"),
        meta: {
          level: 3,
        },
      },
      {
        path: "/space/detail/:id",
        name: "spaceDetail",
        component: () => import("../pages/spaceDetail"),
        meta: {
          level: 3,
        },
      },
      {
        path: "/teacher/detail/:id",
        name: "teacherDetail",
        component: () => import("../pages/teacherDetail"),
        meta: {
          level: 3,
        },
      },
      {
        path: "/mooc/detail/:id",
        name: "moocDetail",
        component: () => import("../pages/moocDetail"),
        meta: {
          level: 3,
        },
      },
      {
        path: "/video/detail/:id",
        name: "videoDetail",
        component: () => import("../pages/videoDetail"),
        meta: {
          level: 3,
        },
      },
      {
        path: "/live/detail/:id",
        name: "liveDetail",
        component: () => import("../pages/liveDetail"),
        meta: {
          level: 3,
        },
      },
      {
        path: "/localFeature/detail/:id",
        name: "localFeatureDetail",
        component: () => import("../pages/localFeatureDetail"),
        meta: {
          level: 3,
        },
      },
      {
        path: "/search",
        name: "search",
        component: () => import("../pages/search"),
      },
    ],
  },
  {
    path: "/consult",
    name: "search",
    component: () => import("../pages/consult/index.vue"),
  },
  {
    path: "/journal",
    name: "journal",
    component: () => import("../pages/journal/index.vue"),
  },
  {
    path: "/comPage/:id",
    name: "comPage",
    component: () => import("../pages/comPage/index.vue"),
  },
  {
    path: "/comPage/comPageDetail/:id/:pid",
    name: "comPageDetail",
    component: () => import("../pages/comPageDetail/index.vue"),
  },
  {
    path: "/paper",
    name: "paper",
    component: () => import("../pages/paper/index.vue"),
  },
  {
    path: "/news",
    name: "search",
    component: () => import("../pages/news/index.vue"),
  },
  {
    path: "/news/detail/:id",
    name: "newsDetail",
    component: () => import("../pages/newsDetail/index.vue"),
  },
  {
    path: "/bookList",
    name: "BookList",
    component: () => import("../pages/bookList/index.vue"),
  },
  {
    path: "/bookDetail/:id",
    name: "bookDetail",
    component: () => import("../pages/bookDetail/index.vue"),
  },
  {
    path: "/consult/detail/:id",
    name: "consultDetail",
    component: () => import("../pages/consult/detail.vue"),
  },
  {
    path: "/appointment",
    name: "Appointment",
    component: () => import("../pages/appointment/index.vue"),
  },

  {
    path: "/subjectresources",
    name: "SubjectResources",
    component: () => import("../pages/LZK/xueKeZiYuan/index.vue"),
  },
  {
    path: "/subjectresources/detail/:id/:cid/:cname",
    name: "consultDetail",
    component: () => import("../pages/LZK/xueKeZiYuanItem"),
  },
  {
    path: "/subjectresources/bookdetail/:id/:cid/:cname",
    name: "bookDetail",
    component: () => import("../pages/LZK/bookDetail"),
  },
  {
    path: "/subjectresources/journalDetail/:id/:cid/:cname",
    name: "journalDetail",
    component: () => import("../pages/LZK/journalDetail"),
  },
  {
    path: "/subjectresources/readerDetail/:id/:cid/:cname",
    name: "readerDetail",
    component: () => import("../pages/LZK/readerDetail"),
  },
  {
    path: "*",
    name: "Page404",
    component: () => import("../pages/404"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

export default router;
